/**
 * Pick the next available name as `{typeLabel} {n}` (n starting at 1).
 * Treats existing names like "Stage player 1" or "Stage player #1" as taken.
 */
export function nextNumberedPlayerName(typeLabel: string, existingNames: Array<string | undefined | null>): string {
  const escaped = typeLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`^${escaped}\\s+#?(\\d+)$`, 'i');
  const used = new Set<number>();

  for (const name of existingNames) {
    if (!name) continue;
    const match = name.trim().match(re);
    if (match) {
      used.add(Number(match[1]));
    }
  }

  let n = 1;
  while (used.has(n)) {
    n += 1;
  }
  return `${typeLabel} ${n}`;
}
